<template>
  <table-layout title="سطل زباله دوره ها" :showSearch="false">
    <template #buttons>

      <router-link :to="{ name: 'CoursesDashboard' }" class="ml-2">
        <b-button pill variant="purple"> بازگشت به صفحه دوره‌ها</b-button>
      </router-link>
    </template>
    <template #table>
      <course-items :items="TrashCourses" :restoreState="true"></course-items>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>
  </table-layout>
</template>

<script>
import courseItems from './courseItems.vue';
import TableLayout from "../TableLayout.vue";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {mapGetters} from "vuex";
import Pagination from "../Pagination.vue";

export default {
  name: "trashItems",
  components: {TableLayout, courseItems, Pagination},
  data() {
    return {
      tableAttributes,
    };
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Course/getTrash", page);
    },
  },
  computed: {
    ...mapGetters({
      TrashCourses: "Course/getTrash",
      paginationMeta: "Course/getPaginationMeta",
    }),
  },
  mounted() {
    this.$store.dispatch("Course/getTrash");
  }
};
</script>